import { UnlinkIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * CustomLoadingError — Universal error screen component
 * For displaying loading/request failure states in pages and components
 */
export function CustomLoadingError() {
  return (
    <div className="flex flex-col justify-center items-center px-10 text-center min-h-[60vh]">
      <p className="text-tx-muted mb-10">
        <UnlinkIcon size={48} />
      </p>
      <div className="text-tx-default font-semibold text-lg mb-2">
        Load Failed
      </div>
      <div className="text-tx-muted text-base leading-5">
        Network error or server issue. Please try again later.
      </div>

      <Button
        variant="destructive"
        size="lg"
        className="mt-10"
        onClick={() => window.location.reload()}
      >
        Retry
      </Button>
    </div>
  );
}

export default CustomLoadingError;
